import React from "react";
import "./PromoBanner.css";

const PromoBanner = () => {
  return (
    <section className="promo-banner">
      <div className="promo-banner-container">
        <p>
          🚀 Save big on your first-year domain purchase — grab premium
          extensions like <strong>.com</strong>, <strong>.in</strong>,{" "}
          <strong>.org</strong> at launch-ready pricing.
        </p>

        <p style={{ marginTop: "8px", fontWeight: "500" }}>
          Build your brand today with <strong>DoHostingPay</strong> and go live
          in minutes.
        </p>
      </div>
    </section>
  );
};

export default PromoBanner;